<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const visible = defineModel<boolean>()
const emit = defineEmits(['handleUploadNewImage', 'handleCropImage'])

const handleUploadNewImage = () => {
  emit('handleUploadNewImage')
}

const handleCropImage = () => {
  emit('handleCropImage')
}
</script>
<template>
  <el-dialog v-model="visible" width="330px" :show-close="true" :title="null" mt-15>
    <template #header>
      <div text-main text-xl mt--1.5 text-red-500 px-2>{{ t('portrait.error_img_tip') }}</div>
    </template>
    <div px-2 w-full>
      <!-- <div text-main text-lg>{{ t('portrait.error_img_tip') }}</div> -->
      <div flex items-center gap-2>
        <div text-main text-base>{{ t('portrait.bad_example') }}</div>
      </div>
      <img
        src="https://lp-file.lifepage.cc/operation/20251205200242317_TjpJoWw6Vs.png?x-oss-process=image/format,png/resize,w_357,m_lfit"
        alt=""
        mx-auto
        mt-2 />
      <div flex items-center gap-4 mt-4 w-full justify-center>
        <div text-main text-base mr-8>{{ t('portrait.good_example') }}</div>
        <img
          src="https://lp-file.lifepage.cc/operation/20251205200328922_TjpNFttXYe.png?x-oss-process=image/format,png/resize,w_99,m_lfit"
          alt=""
          mt-2 />
      </div>
      <div flex w-full items-center justify-center mt-10 gap-2>
        <div
          btn-outline-yellow
          text-portrait
          bg-transparent
          text-center
          flex-1
          py-1.5
          cursor-pointer
          text-lg
          @click="handleUploadNewImage">
          {{ t('portrait.upload_single_photo') }}
        </div>
        <div
          btn-solid-yellow
          text-white
          bg-portrait
          flex-1
          text-center
          py-1.5
          cursor-pointer
          text-lg
          @click="handleCropImage">
          {{ t('portrait.to_crop') }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped></style>
